// Support is a service identity, not a public user Vault.
export function isSupportCode(code) {
  return String(code || '').trim().toUpperCase() === 'SUP';
}
